import { Box, ListItem, Tooltip, Typography } from '@material-ui/core'
import type { ReactNode } from 'react'
import { memo } from 'react'
import { TooltipDelays } from '../../../constants/tooltips'
import type { IconType } from './itemCreator'
import styles from './sidebar.module.css'
import { Info } from '@material-ui/icons'

type Props = {
  name: string // displayed text
  modalId: string // should match the isModalOpen in Sidebar.js
  children?: ReactNode // optional, if provided overrides styles and what is displayed in ListItem
  isSidebarOpen: boolean
  icon?: IconType
  isHighlighted: boolean
  shouldCompleteProfile: boolean
  toggleModal: (modalName: string) => void
  disabled?: boolean
}

// eslint-disable-next-line react/display-name
const SidebarActionItem = memo((props: Props) => {
  const { name, modalId, children, isSidebarOpen, icon, isHighlighted, shouldCompleteProfile, toggleModal, disabled } = props

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
    <ListItem
      id={name}
      button
      onClick={shouldCompleteProfile ? () => toggleModal('completeProfile') : () => toggleModal(modalId)}
      className={isHighlighted ? styles.itemHighlighted : styles.item}
      disabled={disabled}
    >
      <Box display="flex" alignItems="center">
        {icon && (
          <Box pr={2}>
            {isSidebarOpen ? (
              icon
            ) : (
              <Tooltip leaveDelay={TooltipDelays.WITHOUT_LINKS} placement="right" title={name}>
                {icon}
              </Tooltip>
            )}
          </Box>
        )}
        {isSidebarOpen && (children || <Typography>{name}</Typography>)}
      </Box>
    </ListItem>
    {disabled &&
      <Tooltip title="Creating a job is disabled because your company is not approved." placement='right'>
        <div style={{ paddingRight: 10, cursor: 'pointer' }}>
          <Info />
        </div>
      </Tooltip>}
    </div>
  )
})

export default SidebarActionItem
